import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import Banner from '@cpg-its/ads.containers.banner';
import { useSelector } from 'react-redux';
import React from 'react';
import { PageContainer } from '../../../../../../global/components/layout/page-container';
import { TcsmStates } from '../../../../../../root/tcsm-model';
import { NewHireProps } from '../../../../models/arc-epi-props';
import { useNewHireEnrollmentCoverage } from '../../hooks/useNewHireEnrollmentCoverage';
import { CoverageEnrollmentForm } from './coverage-enrollment-form';
import { gridPageStyles } from '../../../../../../global/constants/theme/styles/layout/grid-page-layout';
import { MainContent } from '../../../../../../global/components/layout/main-content-container';
import { CoveragePageContentModel } from '../../../new-participant-enrollment/models/page-content-models';
import { ConfirmationStatusCode } from '../../models/new-hire-confirmation-models';
import { NewHireEventType } from '../../../../constants/constant-strings';
import { ApiStatuses } from '../../../../../../global/models/api-model';
import { ApiErrorPage } from '../../../../../../global/components/api-error-page';

interface Props {
	basePath: string;
	queryString: string;
	getEmployerIdHook: any;
	getBillingAccountOwnerCn?: any;
	isParticipant?: boolean;
	customContentModel?: CoveragePageContentModel;
	confirmationCode?: ConfirmationStatusCode;
	eventType?: string;
	isDioApprover?: boolean;
	qualifyingEventDateOverwrite?: string;
}

export function CoverageEnrollment(props: Props) {
	const { basePath, queryString, getEmployerIdHook, isParticipant, customContentModel, confirmationCode, getBillingAccountOwnerCn, eventType, isDioApprover, qualifyingEventDateOverwrite } = props;
	const newHirePropsLoaded = useSelector<TcsmStates, boolean>(state => state.epiProps?.newHireSettingsState?.contentLoaded);
	const newHireProps = useSelector<TcsmStates, NewHireProps>(state => state.epiProps?.newHireSettingsState?.epiContent);
	const employeeGuid = useSelector<TcsmStates, string>(state => state.employmentState?.currentEmployee?.guid);
	const employerGuid = getEmployerIdHook();
	const coverageLoaded = useNewHireEnrollmentCoverage(employeeGuid, employerGuid, queryString, isDioApprover, eventType);
	const pageClasses = gridPageStyles();
	const error = useSelector<TcsmStates, ApiStatuses>(state => state.newHireEnrollmentState?.apiError);
	const errorMessage = useSelector<TcsmStates, string>(state => state.newHireEnrollmentState?.apiErrorMessage);


	function RenderLateEnrollmentWarning() {
		// TODO: Adjust condition
		const isLateEnrollment = true;

		if (!isLateEnrollment || !newHireProps?.lateEnrollmentCoverageWarningMessage) return null;

		return (
			<Banner
				banner={{
					type: 'warning',
					label: <p><strong>{newHireProps?.lateEnrollmentCoverageWarningMessage}</strong></p>,
				}} />
		);
	}

	if (error === ApiStatuses.Failure) {
		return <ApiErrorPage error={errorMessage || newHireProps?.unExpectedApiErorrMessage} />;
	}

	if (!newHirePropsLoaded || !coverageLoaded) {
		return <LoadingCircle />;
	}

	return (
		<PageContainer>
			<MainContent fullWidth>
				<div className={pageClasses.gridPageContainer}>
					<RenderLateEnrollmentWarning />
					<CoverageEnrollmentForm
						basePath={basePath}
						queryString={queryString}
						getEmployerIdHook={getEmployerIdHook}
						isParticipant={isParticipant}
						customContentModel={customContentModel}
						confirmationCode={confirmationCode}
						getBillingAccountOwnerCn={getBillingAccountOwnerCn}
						eventType={eventType}
						isDioApprover={isDioApprover}
						qualifyingEventDateOverwrite={qualifyingEventDateOverwrite}
					/>
				</div>
			</MainContent>
		</PageContainer>
	);
}

CoverageEnrollment.defaultProps = {
	isParticipant: false,
	customContentModel: null,
	confirmationCode: null,
	getBillingAccountOwnerCn: null,
	eventType: NewHireEventType,
	isDioApprover: false,
	qualifyingEventDateOverwrite: null,
};